export default "__VITE_ASSET__Y8taA77a__"